import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { Header, Section, Field } from "./TextsTab";

export default function SecurityTab() {
  const [cur, setCur] = useState("");
  const [n1, setN1] = useState("");
  const [n2, setN2] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!cur || !n1 || !n2) return toast.error("Completá todos los campos");
    if (n1 !== n2) return toast.error("Las contraseñas no coinciden");
    if (n1.length < 4) return toast.error("Mínimo 4 caracteres");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: n1 });
      toast.success("Contraseña actualizada");
      setCur(""); setN1(""); setN2("");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Error");
    } finally { setSaving(false); }
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <Header title="Seguridad" subtitle="Cambí la contraseña del usuario administrador." />
      <form onSubmit={submit} className="glass rounded-2xl p-6 space-y-4">
        <Field label="Contraseña actual" type="password" value={cur} onChange={setCur} />
        <Field label="Nueva contraseña" type="password" value={n1} onChange={setN1} />
        <Field label="Confirmar nueva contraseña" type="password" value={n2} onChange={setN2} />
        <button type="submit" disabled={saving} className="btn-primary px-5 py-2.5 rounded-lg inline-flex items-center gap-2 font-medium">
          <KeyRound className="w-4 h-4" /> {saving ? "Guardando…" : "Actualizar contraseña"}
        </button>
      </form>
      <div className="glass rounded-2xl p-6">
        <div className="mono text-[10px] uppercase tracking-[0.25em] text-[#7da3ff] mb-3">Sugerencias</div>
        <ul className="text-sm text-[#cad8ff] space-y-1.5 list-disc list-inside">
          <li>Cambí la contraseña por defecto (admin/admin) en el primer acceso.</li>
          <li>Usá una contraseña robusta (más de 12 caracteres, mayúsculas/números/símbolos).</li>
          <li>Cerrá sesión cuando termines y no la dejes guardada en navegadores compartidos.</li>
        </ul>
      </div>
    </div>
  );
}
